<script lang="ts">
	import { PUBLIC_BASE_URL } from '$env/static/public';
  import { browser } from "$app/environment";
  import { GtmStore } from '$lib/utils/gtm-store';
  import { StructureUtils } from '$lib/utils/structured-utils';
  import type { PageData } from "./$types";
  import { customPageOptions } from '$lib/utils/layout-store';
	import { goto } from '$app/navigation';
  import { removeHTML } from '$lib/utils/formatter';
  // Components
  import { Head } from '$lib/components/atoms/Head'
  import { Breadcrumb, BreadcrumbItem } from '$lib/components/molecules/Breadcrumb';
  import { Section, SectionTight } from '$lib/components/organisms/Section';
  import { InstructorCardHeader } from '$lib/components/organisms/Card';
  import { ScrollableCardWrapper } from '$lib/components/organisms/Layout';

  export let data: PageData;
  const { instructor, instructorLinkedCourses, instructorTotalCourses } = data;

  customPageOptions({bodyStyle: 'gray'});

  if (!instructor) {
    goto('/');
  }

  /******************** GTM EVENT PUSH *************************/
  GtmStore.pushEvent({
    pageCategory: `Network - Docenti ${instructor.idInstructor} ${instructor.name} ${instructor.surname}`,
  });
  /*************************************************************/

  const breadcrumbJson = StructureUtils.getBreadcrumbStructure(
    [
      {
        name: 'Home',
        url: PUBLIC_BASE_URL,
      },
      {
        name: 'Docenti',
        url: `${PUBLIC_BASE_URL}docenti`,
      },
      {
        name: `${instructor.name} ${instructor.surname}`,
        url: `${PUBLIC_BASE_URL}${instructor.name.toLowerCase()}-${instructor.surname.toLowerCase()}`,
      }
    ],
    true
  );

  let ldScriptTag = '';
  ldScriptTag = StructureUtils.createScriptTag(JSON.stringify([breadcrumbJson]));

  const seoDetails = {
    title: `Ti presentiamo ${instructor.name} ${instructor.surname}`,
    description: instructor.description ? removeHTML(instructor.description).slice(0, 160) : '',
    url:  instructor ? `/docenti/${instructor.slug}` : '/docenti',
    ldScriptTag: ldScriptTag,
  };
</script>

<Head appendCompany {seoDetails} />

<Breadcrumb disableLastElementLink>
  <BreadcrumbItem>
    <a href="/">Home</a>
  </BreadcrumbItem>
  <BreadcrumbItem>
    <a href="/docenti">Docenti</a>
  </BreadcrumbItem>
  <BreadcrumbItem current>
    <a href="/docenti/{instructor.slug}">{instructor.name} {instructor.surname}</a>
  </BreadcrumbItem>
</Breadcrumb>

<SectionTight variant="transparent" class="bg-gray-50 py-6 lg:py-12" tighter>
  <InstructorCardHeader {instructor}>
    <svelte:fragment>
      {@html instructor.description}
    </svelte:fragment>
  </InstructorCardHeader>
</SectionTight>

{#if instructorLinkedCourses.length > 0 && instructorTotalCourses > 0}
  <Section class="py-6 md:py-14">
    <svelte:fragment slot="header">
      <p class="subtitle v-small mb-2">Corsi correlati</p>
      <h3>Scopri i percorsi associati a questo docente</h3>
    </svelte:fragment>

    <ScrollableCardWrapper courses={instructorLinkedCourses} />
  </Section>
{/if}
